import { render, staticRenderFns } from "./consultationService.vue?vue&type=template&id=490154ac&scoped=true"
import script from "./consultationService.vue?vue&type=script&lang=js"
export * from "./consultationService.vue?vue&type=script&lang=js"
import style0 from "./consultationService.vue?vue&type=style&index=0&id=490154ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490154ac",
  null
  
)

export default component.exports